import { call, put, takeLatest } from "redux-saga/effects";
import {
  //GET_ALLAPPRAISAL_QUESTIONS,
  ADD_APPRAISAL_QUESTIONS,
  UPDATE_APPRAISAL_QUESTIONS,
  DELETE_APPRAISAL_QUESTIONS,
 // GET_ALLAPPRAISAL_QUESTIONS_SUCCESS,
  ADD_APPRAISAL_QUESTIONS_SUCESS,
  UPDATE_APPRAISAL_QUESTIONS_SUCESS,
  DELETE_APPRAISAL_QUESTIONS_SUCESS,
  GET_APPRAISAL_QUESTIONS,
  GET_APPRAISAL_QUESTIONS_SUCCESS,
  DELETE_APPRAISAL_QUESTIONS_ERROR,

} from "../../redux/actions/actionType";
import api from "../../apis/api";

// api function.
function* getAllAppraisalquestionsApi() {
 // api for get designations
 const response =  yield api.DbAppraisalquestions().GetAppraisalQuestionList();

  return response;
}

function addAppraisalquestionsApi(formData) {
  // api for add designation.
  const response = api.DbAppraisalquestions().AddEditAppraisalquestion(formData);
  return response;
}
function updateApprisalquestionsApi(formData) {
  // api for update designation.
  const response = api.DbAppraisalquestions().AddEditAppraisalquestion(formData);
  return response;
}
function DeleteAppraisalquestionsApi(delId) {
  // api for delete designation
  const response = api.DbAppraisalquestions().DeleteAppraisalquestion(delId);
  return response;
}

// get designation list.
export function* handleGetAppraisalQuestions() {
  try {
    const response = yield call(getAllAppraisalquestionsApi);
    yield put({ type: GET_APPRAISAL_QUESTIONS_SUCCESS, payload: response });
    //console.log(response,'appp')
  } catch (error) {
  

}}
export function* handleAddAppraisalquestions({ payload }) {
  try {
    const responsea = yield call(addAppraisalquestionsApi, payload);

    payload={...payload,"appraisalQuestionId":responsea.data}
    yield put({ type: ADD_APPRAISAL_QUESTIONS_SUCESS, payload: payload });

  } catch (error) {
  
  }
}
export function* handleUpdateAppraisalquestions({ payload }) {
  try {
    const responsea = yield call(updateApprisalquestionsApi, payload);
    yield put({ type: UPDATE_APPRAISAL_QUESTIONS_SUCESS, payload: payload });
    const response = yield call(getAllAppraisalquestionsApi);
    yield put({ type: GET_APPRAISAL_QUESTIONS_SUCCESS, payload: response });
  } catch (error) {

  }
}
export function* handleDeleteAppraisalquestions({ payload }) {
  try {
    const responsea = yield call(DeleteAppraisalquestionsApi, payload);
    yield put({ type: DELETE_APPRAISAL_QUESTIONS_SUCESS, payload: payload });
    const response = yield call(getAllAppraisalquestionsApi);
    yield put({ type: GET_APPRAISAL_QUESTIONS_SUCCESS, payload: response });
  } catch (error) {
    yield put({ type: DELETE_APPRAISAL_QUESTIONS_ERROR});

  }
}

// watch function.
export function* apprisalQuestionsWatchFun() {
  yield takeLatest(GET_APPRAISAL_QUESTIONS, handleGetAppraisalQuestions);
  yield takeLatest(ADD_APPRAISAL_QUESTIONS,handleAddAppraisalquestions); 
  yield takeLatest(UPDATE_APPRAISAL_QUESTIONS, handleUpdateAppraisalquestions);
  yield takeLatest(DELETE_APPRAISAL_QUESTIONS, handleDeleteAppraisalquestions);
}
